import message_create           from "./message_create.js";
import message_delete           from "./message_delete.js";
import message_edit             from "./message_edit.js";

import MessageViewer            from "./common/message.js";
import RoleViewer               from "./common/role.js";
import ChannelViewer            from "./common/channel.js";
import BotViewer                from "./common/bot.js";
import BanViewer                from "./common/ban.js";
import VoiceViewer              from "./common/voice.js";
import MemberViewer             from "./common/member.js";
import MemberRoleViewer         from "./common/memberRole.js";
import PresenceViewer           from "./common/presence.js";
import AutoModerationViewer     from "./common/autoModeration.js";

const LogsDefinitions = [
    message_create,
    message_delete,
    message_edit,
    {
        tags: ["AutoModeration"],
        name: "auto_moderation_rule_create",
        viewer: AutoModerationViewer,
        definition: (i18n, log) => {
            return i18n("logs_definition.auto_moderation_rule_create");
        },
        filter: {
            icon: "rule",
            name: (i18n) => "Création de règle de modération automatique",
        },
        variables: {
            rule: (log, renderer) => {
                const id = log.extra.rule;
                const changes = log.extra.changes.map((entry) => ([entry.key, entry.new]));
                const rule = Object.assign(
                    Object.fromEntries(changes),
                    { id },
                );
                return renderer.renderAutoModerationRule(rule);
            },
        },
    },
    {
        tags: ["AutoModeration"],
        name: "auto_moderation_rule_update",
        viewer: AutoModerationViewer,
        definition: (i18n, log) => {
            return i18n("logs_definition.auto_moderation_rule_update");
        },
        filter: {
            icon: "rule",
            name: (i18n) => "Mise à jour de règle de modération automatique",
        },
    },
    {
        tags: ["AutoModeration"],
        name: "auto_moderation_rule_delete",
        viewer: AutoModerationViewer,
        definition: (i18n, log) => {
            return i18n("logs_definition.auto_moderation_rule_delete");
        },
        filter: {
            icon: "rule",
            name: (i18n) => "Suppression de règle de modération automatique",
        },
        variables: {
            rule: (log, renderer) => {
                const id = log.extra.rule;
                const changes = log.extra.changes.map((entry) => ([entry.key, entry.old]));
                const rule = Object.assign(
                    Object.fromEntries(changes),
                    { id },
                );
                return renderer.renderAutoModerationRule(rule);
            },
        },
    },
    {
        tags: ["Emoji"],
        name: "emoji_create",
        viewer: null,
        definition: (i18n, log) => {
            return i18n("logs_definition.emoji_create");
        },
        filter: {
            icon: "emoji_emotions",
            name: (i18n) => "Création d'émoji",
        },
        variables: {
            emoji: (log, renderer) => {
                const id = log.extra.emoji;
                const changes = log.extra.changes.map((entry) => ([entry.key, entry.new]));
                const emoji = Object.assign(
                    Object.fromEntries(changes),
                    { id },
                );

                return (
                    <span class="log-code">
                        <img src={`https://cdn.discordapp.com/emojis/${emoji.id}.png`} alt={emoji.name} />
                        {emoji.name}
                    </span>
                );
            },
        },
    },
    {
        tags: ["Emoji"],
        name: "emoji_update",
        viewer: null,
        definition: (i18n, log) => {
            return i18n("logs_definition.emoji_update");
        },
        filter: {
            icon: "emoji_emotions",
            name: (i18n) => "Mise à jour d'émoji",
        },
        variables: {
            emoji: (log, renderer, ...args) => {
                const id = log.extra.emoji;
                const changes = log.extra.changes.map((entry) => ([entry.key, entry.old]));
                const emoji = Object.assign(
                    Object.fromEntries(changes),
                    { id },
                );

                return (
                    <span class="log-code">
                        <img src={`https://cdn.discordapp.com/emojis/${emoji.id}.png`} alt={emoji.name} />
                        {emoji.name}
                    </span>
                );
            },
        },
    },
    {
        tags: ["Emoji"],
        name: "emoji_delete",
        viewer: null,
        definition: (i18n, log) => {
            return i18n("logs_definition.emoji_delete");
        },
        filter: {
            icon: "emoji_emotions",
            name: (i18n) => "Suppression d'émoji",
        },
        variables: {
            emoji: (log, renderer) => {
                const id = log.extra.emoji;
                const changes = log.extra.changes.map((entry) => ([entry.key, entry.old]));
                const emoji = Object.assign(
                    Object.fromEntries(changes),
                    { id },
                );

                return (
                    <span class="log-code">
                        <img src={`https://cdn.discordapp.com/emojis/${emoji.id}.png`} alt={emoji.name} />
                        {emoji.name}
                    </span>
                );
            },
        },
    },
    {
        tags        : [ "Guild" ],
        name        : "guild_available",
        viewer      : null,
        definition: (i18n, log) => {
            return i18n("logs_definition.guild_available");
        },
        filter: {
            icon: "public",
            name: (i18n) => "Serveur disponible",
        },
    },
    {
        tags        : [ "Role" ],
        name        : "role_position_update",
        viewer      : RoleViewer,
        definition: (i18n, log) => {
            return i18n("logs_definition.role_position_update");
        },
        filter: {
            icon: "sell",
            name: (i18n) => "Mise à jour de la position d'un rôle",
        },
        variables: {
            role: (log, renderer) => renderer.renderRole(log.extra.role),
        },
    },
    {
        tags        : [ "Channel" ],
        name        : "channel_position_update",
        viewer      : ChannelViewer,
        definition: (i18n, log) => {
            return i18n("logs_definition.channel_position_update");
        },
        filter: {
            icon: "tag",
            name: (i18n) => "Mise à jour de la position d'un salon",
        },
    },
    {
        tags        : [ "Role" ],
        name        : "role_create",
        viewer      : RoleViewer,
        definition: (i18n, log) => {
            return i18n("logs_definition.role_create");
        },
        filter: {
            icon: "sell",
            name: (i18n) => "Création de rôle",
        },
        variables: {
            role: (log, renderer) => {
                const id        = log.extra.role;
                const changes   = log.extra.changes.map((entry) => ([ entry.key, entry.new ]));

                const role = Object.assign(
                    Object.fromEntries(changes),
                    { id },
                );

                return renderer.renderRole(role);
            },
        },
    },
    {
        tags        : [ "Role" ],
        name        : "role_update",
        viewer      : RoleViewer,
        definition: (i18n, log) => {
            return i18n("logs_definition.role_update");
        },
        filter: {
            icon: "sell",
            name: (i18n) => "Mise à jour de rôle",
        },
        variables: {
            role: (log, renderer) => {
                const id        = log.extra.role;
                const changes   = (log.extra.changes || []).map((entry) => ([ entry.key, entry.new ?? entry.old ]));

                const role = Object.assign(
                    Object.fromEntries(changes),
                    { id },
                );

                return renderer.renderRole(role);
            },
        },
    },
    {
        tags        : [ "Role" ],
        name        : "role_delete",
        viewer      : RoleViewer,
        definition: (i18n, log) => {
            return i18n("logs_definition.role_delete");
        },
        filter: {
            icon: "sell",
            name: (i18n) => "Suppression de rôle",
        },
        variables: {
            role: (log, renderer) => {
                const id        = log.extra.role;
                const changes   = log.extra.changes.map((entry) => ([ entry.key, entry.old ]));

                const role = Object.assign(
                    Object.fromEntries(changes),
                    { id },
                );

                return renderer.renderRole(role);
            },
        },
    },
    {
        tags        : [ "Bot" ],
        name        : "bot_add",
        viewer      : BotViewer,
        definition: (i18n, log) => {
            return i18n("logs_definition.bot_add");
        },
        filter: {
            icon: "smart_toy",
            name: (i18n) => "Ajout de bot",
        },
    },
    {
        tags        : [ "Channel", "Permission" ],
        name        : "channel_overwrite_create",
        viewer      : ChannelViewer,
        definition: (i18n, log) => {
            return i18n("logs_definition.channel_overwrite_create");
        },
        filter: {
            icon: "tag",
            name: (i18n) => "Création d'une autorisation de salon",
        },
    },
    {
        tags        : [ "Channel", "Permission" ],
        name        : "channel_overwrite_update",
        viewer      : ChannelViewer,
        definition: (i18n, log) => {
            return i18n("logs_definition.channel_overwrite_update");
        },
        filter: {
            icon: "tag",
            name: (i18n) => "Mise à jour d'une autorisation de salon",
        },
    },
    {
        tags        : [ "Channel", "Permission" ],
        name        : "channel_overwrite_delete",
        viewer      : ChannelViewer,
        definition: (i18n, log) => {
            return i18n("logs_definition.channel_overwrite_delete");
        },
        filter: {
            icon: "tag",
            name: (i18n) => "Suppression d'une autorisation de salon",
        },
    },
    {
        tags        : [ "Message", "Reaction" ],
        name        : "message_reaction_add",
        viewer      : MessageViewer,
        definition: (i18n, log) => {
            return i18n("logs_definition.message_reaction_add");
        },
        filter: {
            icon: "add_reaction",
            name: (i18n) => "Ajout de réaction",
        },
    },
    {
        tags        : [ "Message", "Reaction" ],
        name        : "message_reaction_remove",
        viewer      : MessageViewer,
        definition: (i18n, log) => {
            return i18n("logs_definition.message_reaction_remove");
        },
        filter: {
            icon: "heart_minus",
            name: (i18n) => "Retrait de réaction",
        },
    },
    {
        tags        : [ "Message" ],
        name        : "message_bulk_delete",
        viewer      : MessageViewer,
        definition: (i18n, log) => {
            return i18n("logs_definition.message_bulk_delete");
        },
        filter: {
            icon: "delete",
            name: (i18n) => "Suppression massive de messages",
        },
    },
    {
        tags        : [ "Voice" ],
        name        : "voice_join",
        viewer      : VoiceViewer,
        definition: (i18n, log) => {
            return i18n("logs_definition.voice_join");
        },
        filter: {
            icon: "login",
            name: (i18n) => "Connexion vocale",
        },
    },
    {
        tags        : [ "Voice" ],
        name        : "voice_move",
        viewer      : VoiceViewer,
        definition: (i18n, log) => {
            return i18n("logs_definition.voice_move");
        },
        filter: {
            icon: "exit_to_app",
            name: (i18n) => "Déplacement vocal",
        },
    },
    {
        tags        : [ "Voice" ],
        name        : "voice_leave",
        viewer      : VoiceViewer,
        definition: (i18n, log) => {
            return i18n("logs_definition.voice_leave");
        },
        filter: {
            icon: "logout",
            name: (i18n) => "Déconnexion vocale",
        },
    },
    {
        tags        : [ "Voice" ],
        name        : "voice_state_update",
        viewer      : VoiceViewer,
        definition: (i18n, log) => {
            return i18n("logs_definition.voice_state_update");
        },
        filter: {
            icon: "volume_up",
            name: (i18n) => "Mise à jour de l'état vocal",
        },
    },
    {
        tags        : [ "Member" ],
        name        : "member_join",
        viewer      : MemberViewer,
        definition: (i18n, log) => {
            return i18n("logs_definition.member_join");
        },
        filter: {
            icon: "login",
            name: (i18n) => "Arrivée d'un membre",
        },
    },
    {
        tags        : [ "Member" ],
        name        : "member_leave",
        viewer      : MemberViewer,
        definition: (i18n, log) => {
            return i18n("logs_definition.member_leave");
        },
        filter: {
            icon: "logout",
            name: (i18n) => "Départ d'un membre",
        },
    },
    {
        tags        : [ "Presence" ],
        name        : "presence_update",
        viewer      : PresenceViewer,
        definition: (i18n, log) => {
            return i18n("logs_definition.presence_update");
        },
        filter: {
            icon: "arrow_upload_ready",
            name: (i18n) => "Mise à jour de la présence",
        },
    },
    {
        tags: [ "Member" ],
        name: "member_move",
        viewer: MemberViewer,
        definition: (i18n, log) => {
            return log.target
                ? i18n("logs_definition.member_move_has_target")
                : i18n("logs_definition.member_move");
        },
        filter: {
            icon: "pan_tool_alt",
            name: (i18n) => "Déplacement de membre",
        },
    },
    {
        tags: [ "Member" ],
        name: "member_disconnect",
        viewer: MemberViewer,
        definition: (i18n, log) => {
            return log.target
                ? i18n("logs_definition.member_disconnect_has_target")
                : i18n("logs_definition.member_disconnect");
        },
        filter: {
            icon: "left_click",
            name: (i18n) => "Déconnexion de membre",
        },
    },
    {
        tags: [ "Member" ],
        name: "member_timeout_create",
        viewer: MemberViewer,
        definition: (i18n, log) => {
            return i18n("logs_definition.member_timeout_create");
        },
        filter: {
            icon: "update",
            name: (i18n) => "Timeout créé",
        },
    },
    {
        tags: [ "Member" ],
        name: "member_timeout_cancel",
        viewer: MemberViewer,
        definition: (i18n, log) => {
            return i18n("logs_definition.member_timeout_cancel");
        },
        filter: {
            icon: "history",
            name: (i18n) => "Timeout annulé",
        },
    },
    {
        tags: [ "Member" ],
        name: "member_timeout_update",
        viewer: MemberViewer,
        definition: (i18n, log) => {
            return i18n("logs_definition.member_timeout_update");
        },
        filter: {
            icon: "update",
            name: (i18n) => "Timeout mis à jour",
        },
    },
    {
        tags: [ "Member" ],
        name: "member_ban_add",
        viewer: BanViewer,
        definition: (i18n, log) => {
            return i18n("logs_definition.member_ban_add");
        },
        filter: {
            icon: "block",
            name: (i18n) => "Bannissement",
        },
    },
    {
        tags: [ "Member" ],
        name: "member_ban_remove",
        viewer: BanViewer,
        definition: (i18n, log) => {
            return i18n("logs_definition.member_ban_remove");
        },
        filter: {
            icon: "history",
            name: (i18n) => "Débanissement",
        },
    },
    {
        tags: [ "Member" ],
        name: "member_kick",
        viewer: MemberViewer,
        definition: (i18n, log) => {
            return i18n("logs_definition.member_kick");
        },
        filter: {
            icon: "door_open",
            name: (i18n) => "Expulsion de membre",
        },
    },
    {
        tags: ["Channel"],
        name: "channel_create",
        viewer: ChannelViewer,
        definition: (i18n, log) => {
            return i18n("logs_definition.channel_create");
        },
        filter: {
            icon: "tag",
            name: (i18n) => "Création de salon",
        },
        variables: {
            channel: (log, renderer) => {
                const id        = log.channel;
                const changes   = log.extra.changes.map((entry) => ([ entry.key, entry.new ]));

                const channel = Object.assign(
                    Object.fromEntries(changes),
                    { id },
                );

                return renderer.renderChannelDirect(channel.id, channel);
            },
        },
    },
    {
        tags: ["Channel"],
        name: "channel_update",
        viewer: ChannelViewer,
        definition: (i18n, log) => {
            return i18n("logs_definition.channel_update");
        },
        filter: {
            icon: "tag",
            name: (i18n) => "Mise à jour de salon",
        },
    },
    {
        tags: ["Channel"],
        name: "channel_delete",
        viewer: ChannelViewer,

        definition: (i18n, log) => {
            return i18n("logs_definition.channel_delete");
        },

        variables: {
            channel: (log, renderer) => {
                const id        = log.channel;
                const changes   = log.extra.changes.map((entry) => ([ entry.key, entry.old ]));

                const channel = Object.assign(
                    Object.fromEntries(changes),
                    { id },
                );

                return renderer.renderChannelDirect(channel.id, channel);
            },
        },

        filter: {
            icon: "tag",
            name: (i18n) => "Suppression de salon",
        },
    },
    {
        tags: ["AutoModeration"],
        name: "auto_moderation_flag_to_channel",
        viewer: AutoModerationViewer,
        definition: (i18n, log) => {
            return i18n("logs_definition.auto_moderation_flag_to_channel");
        },
        filter: {
            icon: "visibility",
            name: (i18n) => "Signalement en salon",
        },
    },
    {
        tags: ["AutoModeration"],
        name: "auto_moderation_block_message",
        viewer: AutoModerationViewer,
        definition: (i18n, log) => {
            return i18n("logs_definition.auto_moderation_block_message");
        },
        filter: {
            icon: "visibility",
            name: (i18n) => "Message bloqué par modération automatique",
        },
    },
    {
        tags: ["AutoModeration"],
        name: "automod_action_execution",
        viewer: AutoModerationViewer,

        definition: (i18n, log) => {
            return i18n("logs_definition.automod_action_execution");
        },

        filter: {
            icon: "visibility",
            name: (i18n) => "Action effectuée par la modération automatique",
        },

        variables: {
            matched: (log, renderer) => {
                return <span class="log-code">{log.extra.matchedContent}</span>;
            },
        },
    },
    {
        tags: [ "Voice" ],
        name: "voice_state_video",
        viewer: VoiceViewer,
        definition: (i18n, log) => {
            return log.extra.video
                ? i18n("logs_definition.voice_state_video.turn_on")
                : i18n("logs_definition.voice_state_video.turn_off");
        },
        filter: {
            icon: "videocam",
            name: (i18n) => "État vidéo activé/désactivé",
        },
    },
    {
        tags: [ "Voice" ],
        name: "voice_state_stream",
        viewer: VoiceViewer,
        definition: (i18n, log) => {
            return log.extra.streaming
                ? i18n("logs_definition.voice_state_stream.turn_on")
                : i18n("logs_definition.voice_state_stream.turn_off");
        },
        filter: {
            icon: "screen_share",
            name: (i18n) => "État streaming activé/désactivé",
        },
    },
    {
        tags: [ "User" ],
        name: "user_update_username",
        viewer: MemberViewer,

        definition: (i18n, log) => {
            return i18n("logs_definition.user_update_username");
        },

        filter: {
            icon: "id_card",
            name: (i18n) => "Changement de nom d'utilisateur",
        },
    },
    {
        tags: [ "User" ],
        name: "user_update_globalname",
        viewer: MemberViewer,

        definition: (i18n, log) => {
            return i18n("logs_definition.user_update_globalname");
        },

        filter: {
            icon: "id_card",
            name: (i18n) => "Changement de nom global",
        },
    },
    {
        tags: [ "User" ],
        name: "user_update_avatar",
        viewer: MemberViewer,

        definition: (i18n, log) => {
            return i18n("logs_definition.user_update_avatar");
        },

        filter: {
            icon: "wallpaper",
            name: (i18n) => "Changement d'avatar",
        },
    },
    {
        tags: [ "User" ],
        name: "user_update_banner",
        viewer: MemberViewer,

        definition: (i18n, log) => {
            return i18n("logs_definition.user_update_banner");
        },

        filter: {
            icon: "wallpaper",
            name: (i18n) => "Changement de bannière",
        },
    },
    {
        tags: [ "Member" ],
        name: "member_update_guild_avatar",
        viewer: MemberViewer,

        definition: (i18n, log) => {
            return i18n("logs_definition.member_update_guild_avatar");
        },

        filter: {
            icon: "wallpaper",
            name: (i18n) => "Changement d'avatar de guilde",
        },
    },
    {
        tags: [ "Member" ],
        name: "member_update_guild_banner",
        viewer: MemberViewer,

        definition: (i18n, log) => {
            return i18n("logs_definition.member_update_guild_banner");
        },

        filter: {
            icon: "wallpaper",
            name: (i18n) => "Changement de bannière de guilde",
        },
    },
    {
        tags: [ "Member" ],
        name: "member_update_nickname",
        viewer: MemberViewer,

        definition: (i18n, log) => {
            if (log.target) {
                if (log.extra.nickname.old && log.extra.nickname.new)
                    return i18n("logs_definition.member_update_nickname.target.replace_nickname");

                if (log.extra.nickname.new)
                    return i18n("logs_definition.member_update_nickname.target.set_nickname");

                return i18n("logs_definition.member_update_nickname.target.remove_nickname");
            } else {
                if (log.extra.nickname.old && log.extra.nickname.new)
                    return i18n("logs_definition.member_update_nickname.self.replace_nickname");

                if (log.extra.nickname.new)
                    return i18n("logs_definition.member_update_nickname.self.set_nickname");

                return i18n("logs_definition.member_update_nickname.self.remove_nickname");
            }
        },

        filter: {
            icon: "id_card",
            name: (i18n) => "Changement de surnom",
        },
    },
    {
        tags: [ "Member" ],
        name: "member_role_add",
        viewer: MemberRoleViewer,

        definition: (i18n, log) => {
            log.target ||= log.executor;
            return i18n("logs_definition.member_role_add");
        },

        filter: {
            icon: "new_label",
            name: (i18n) => "Ajout de rôle",
        },
    },
    {
        tags: [ "Member" ],
        name: "member_role_remove",
        viewer: MemberRoleViewer,

        definition: (i18n, log) => {
            log.target ||= log.executor;
            return i18n("logs_definition.member_role_remove");
        },

        filter: {
            icon: "label_off",
            name: (i18n) => "Suppression de rôle",
        },
    },
    {
        tags: [ "Member" ],
        name: "member_mute_activated",
        viewer: MemberViewer,

        definition: (i18n, log) => {
            log.target ||= log.executor;
            return i18n("logs_definition.member_mute_activated");
        },

        filter: {
            icon: null,
            name: (i18n) => "Activation du mute",
        },
    },
    {
        tags: [ "Member" ],
        name: "member_mute_deactivated",
        viewer: MemberViewer,

        definition: (i18n, log) => {
            log.target ||= log.executor;
            return i18n("logs_definition.member_mute_deactivated");
        },

        filter: {
            icon: null,
            name: (i18n) => "Désactivation du mute",
        },
    },
    {
        tags: [ "Member" ],
        name: "member_deaf_activated",
        viewer: MemberViewer,

        definition: (i18n, log) => {
            log.target ||= log.executor;
            return i18n("logs_definition.member_deaf_activated");
        },

        filter: {
            icon: null,
            name: (i18n) => "Activation du deaf",
        },
    },
    {
        tags: [ "Member" ],
        name: "member_deaf_deactivated",
        viewer: MemberViewer,

        definition: (i18n, log) => {
            log.target ||= log.executor;
            return i18n("logs_definition.member_deaf_deactivated");
        },

        filter: {
            icon: null,
            name: (i18n) => "Désactivation du deaf",
        },
    },
    {
        tags: [ "Custom" ],
        name: "sanction_blacklist",
        viewer: MessageViewer,

        definition: (i18n, log) => {
            log.target ||= log.executor;
            return i18n("logs_definition.sanction_blacklist");
        },

        filter: {
            icon: null,
            name: (i18n) => "Blacklist",
        },
    },
    {
        tags: [ "Custom" ],
        name: "sanction_unblacklist",
        viewer: MessageViewer,

        definition: (i18n, log) => {
            log.target ||= log.executor;
            return i18n("logs_definition.sanction_unblacklist");
        },

        filter: {
            icon: null,
            name: (i18n) => "Unblacklist",
        },
    },
    {
        tags: [ "Custom" ],
        name: "sanction_mute",
        viewer: MessageViewer,

        definition: (i18n, log) => {
            log.target ||= log.executor;
            return i18n("logs_definition.sanction_mute");
        },

        filter: {
            icon: null,
            name: (i18n) => "Sanction: Mute",
        },
    },
    {
        tags: [ "Custom" ],
        name: "sanction_unmute",
        viewer: MessageViewer,

        definition: (i18n, log) => {
            log.target ||= log.executor;
            return i18n("logs_definition.sanction_unmute");
        },

        filter: {
            icon: null,
            name: (i18n) => "Sanction: Unmute",
        },
    },
    {
        tags: [ "Custom" ],
        name: "sanction_warn",
        viewer: MessageViewer,

        definition: (i18n, log) => {
            log.target ||= log.executor;
            return i18n("logs_definition.sanction_warn");
        },

        filter: {
            icon: null,
            name: (i18n) => "Sanction: Avertissement",
        },
    },
    {
        tags: [ "Custom" ],
        name: "utils_voice_find",
        viewer: MessageViewer,

        definition: (i18n, log) => {
            return i18n("logs_definition.utils_voice_find");
        },

        filter: {
            icon: null,
            name: (i18n) => "=find (Crowbot)",
        },
    },
    {
        tags: [ "Custom" ],
        name: "utils_voice_join",
        viewer: MessageViewer,

        definition: (i18n, log) => {
            return i18n("logs_definition.utils_voice_join");
        },

        filter: {
            icon: null,
            name: (i18n) => "=join (Crowbot)",
        },
    },
    {
        tags: [ "Custom" ],
        name: "utils_voice_move",
        viewer: MessageViewer,

        definition: (i18n, log) => {
            return i18n("logs_definition.utils_voice_move");
        },

        filter: {
            icon: null,
            name: (i18n) => "=mv (Crowbot)",
        },
    },
    {
        tags: [ "Invite" ],
        name: "invite_create",
        // @TODO: Invite create
        viewer: null,

        definition: (i18n, log) => {
            return i18n("logs_definition.invite_create");
        },

        filter: {
            icon: null,
            name: (i18n) => "Création d'une invitation",
        },

        variables: {
            invite: (log, renderer) => {
                const id        = log.extra.role;
                const changes   = log.extra.changes.map((entry) => ([ entry.key, entry.new ]));

                const invite = Object.assign(
                    Object.fromEntries(changes),
                    { id },
                );

                return <span class="log-code">{invite.code}</span>;
            },
        },
    },
    {
        tags: [ "Invite" ],
        name: "invite_update",
        // @TODO: Invite create
        viewer: null,

        definition: (i18n, log) => {
            return i18n("logs_definition.invite_update");
        },

        filter: {
            icon: null,
            name: (i18n) => "Mise à jour d'une invitation",
        },

        variables: {
            invite: (log, renderer) => {
                const id        = log.extra.role;
                const changes   = log.extra.changes.map((entry) => ([ entry.key, entry.new ]));

                const invite = Object.assign(
                    Object.fromEntries(changes),
                    { id },
                );

                return <span class="log-code">{invite.code}</span>;
            },
        },
    },
    {
        tags: [ "Invite" ],
        name: "invite_delete",
        // @TODO: Invite create
        viewer: null,

        definition: (i18n, log) => {
            return i18n("logs_definition.invite_delete");
        },

        filter: {
            icon: null,
            name: (i18n) => "Suppression d'une invitation",
        },

        variables: {
            invite: (log, renderer) => {
                const id        = log.extra.role;
                const changes   = log.extra.changes.map((entry) => ([ entry.key, entry.old ]));

                const invite = Object.assign(
                    Object.fromEntries(changes),
                    { id },
                );

                return <><span class="log-code">{invite.code}</span> qui avait <span class="log-code"><b>{invite.uses}</b> utilisations</span></>;
            },
        },
    },
];

export const LogsMapping = new Map(
    LogsDefinitions.map((definition) => [ definition.name, definition ])
);

export default LogsDefinitions;
